/* eslint-disable no-param-reassign */
import $ from 'jquery';

function trackLeadConversion(formId) {
  if (typeof window.gtag_report_conversion === 'function') {
    window.gtag_report_conversion();
  }

  if (parseInt(formId) === 11371) {
    $('body').append(
      '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=529185&conversionId=1451777&fmt=gif" />'
    );
  }
}

function clearForm() {
  $('form[name=contactForm]')[0].reset();
}

function EmpreendimentoContactController($http, $timeout) {
  const vm = this;

  vm.isSuccess = false;
  vm.isSubmiting = false;

  vm.disableSuccess = function () {
    vm.isSuccess = false;
  };

  vm.send = (form) => {
    vm.errors = null;

    if (form.$invalid) {
      vm.isError = true;
      form.$dirty = true;
      form.$$controls.forEach((_, idx) => {
        form.$$controls[idx].$dirty = true;
      });

      return;
    }

    vm.isSubmiting = true;

    trackLeadConversion(vm.formId);
    $timeout(() => {
      // os leads estão sendo enviados para o RD Station utilizando o script de monitoramento do RD Station
      // confira o script visitando o painel do Wordpress > Configurações > Header and Footer > Before the </body> closing tag (footer)
      // https://www.setpar.com.br/wp/wp-admin/options-general.php?page=header-footer%2Fadmin%2Foptions.php
      vm.isSubmiting = false;
      vm.isSuccess = true;
      clearForm();
    }, 1500);
  };
}

export default EmpreendimentoContactController;
